let expectingCloseGlobal = false;
let lostHandler = null;
let reconnectStatusHandler = null;
const midGameReconnectedHandlers = new Set();

export const markExpectingClose = () => {
  expectingCloseGlobal = true;
};

export const clearExpectingClose = () => {
  expectingCloseGlobal = false;
};

export const isExpectingClose = () => expectingCloseGlobal;

export const setConnectionLostHandler = (cb) => {
  lostHandler = cb;
};

export const removeConnectionLostHandler = () => {
  lostHandler = null;
};

export const triggerConnectionLost = () => {
  if (lostHandler && !expectingCloseGlobal) {
    lostHandler();
    clearExpectingClose();
  }
};

// Сервер прислал SESSION_SUPERSEDED: тот же игрок зашел в этот же матч с
// другого устройства/вкладки, старое соединение сервер закрывает сам сразу
// после этого сообщения (см. LobbyPage) — в отличие от triggerConnectionLost,
// это НЕ обрыв сети, поэтому отдельный хендлер и отдельный оверлей
let sessionSupersededHandler = null;

export const setSessionSupersededHandler = (cb) => {
  sessionSupersededHandler = cb;
};

export const removeSessionSupersededHandler = () => {
  sessionSupersededHandler = null;
};

export const triggerSessionSuperseded = () => {
  sessionSupersededHandler?.();
};

export const setReconnectStatusHandler = (cb) => {
  reconnectStatusHandler = cb;
};

export const removeReconnectStatusHandler = () => {
  reconnectStatusHandler = null;
};

// status: {attempt, maxAttempts, retryInMs} во время попытки переподключения
// в матче, либо null, когда попытка завершилась (успехом или отказом)
export const triggerReconnectStatus = (status) => {
  reconnectStatusHandler?.(status);
};

// Несколько независимых потребителей (перерисовка поля в GameContent,
// переподписка на ws.onmessage в OnlineBotRunner и т.п.) должны узнавать о
// восстановлении сокета одновременно — поэтому набор колбэков, а не один
// слот, как у остальных хендлеров в этом файле. Возвращает функцию отписки,
// удобную для использования прямо как return из useEffect
export const addMidGameReconnectedHandler = (cb) => {
  midGameReconnectedHandlers.add(cb);
  return () => midGameReconnectedHandlers.delete(cb);
};

// Сокет восстановлен после хотя бы одной попытки реконнекта в матче — поле
// на экране еще какое-то время перерисовывается под свежий LOAD_STATE, а
// любой код, ранее подменивший ws.onmessage старого сокета (см. выше),
// должен переподписаться на новый
export const triggerMidGameReconnected = () => {
  midGameReconnectedHandlers.forEach((cb) => cb());
};
